import React from "react";
import classes from "./Youtube.module.css";

const Youtube = (props) => {
  return (
    <li className={classes.movie} key={props.id}>
      <h2>
        {props.naam} - {props.titel}
      </h2>
      <iframe
        title={props.titel}
        width={props.width}
        height={props.height}
        src={props.src}
      ></iframe>
    </li>
  );
};

export default Youtube;